// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './pages/Login';
import Signup from './pages/Signup';
import QuestionBank from './pages/QuestionBank';
import QAPage from './pages/QAPage';
import AssignQuestions from './pages/AssingQuestions';
import AdminDashboard from './pages/AdminDashboard';
import AdminView from './pages/AdminView';
import SubjectsAdmin from './pages/SubjectsAdmin';
import ChangePassword from './pages/ChangePassword';
import ResetPassword from './pages/ResetPassword'; // Import the ResetPassword page
import SessionManagement from './pages/SessionManagement'; // Import the SessionManagement page

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/change-password" element={<ChangePassword />} />
        <Route path="/questionbank" element={<QuestionBank />} />
        <Route path="/qa" element={<QAPage />} />
        <Route path="*" element={<Login />} />

        <Route path="/" element={<AdminView />}>
          {/* Nested: these pages render inside AdminView's <Outlet /> */}
          <Route path="dashboard" element={<AdminDashboard />} />
          <Route path="assign" element={<AssignQuestions />} />
          <Route path="subjects" element={<SubjectsAdmin />} />
          <Route path="reset-password" element={<ResetPassword />} /> {/* Add route for ResetPassword */}
          <Route path="sessions" element={<SessionManagement />} /> {/* Add route for SessionManagement */}
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
